export const handleChangeDataPageCheckoutShipping = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_CHECKOUT_SHIPPING', name, value
});